// removed by extract-text-webpack-plugin
module.exports = {"PaginationLink":"_2rdgMHPdxl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/Pagination.scss
// module id = 901
// module chunks = 0